import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ErrorIcon from '@material-ui/icons/Error';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '80%',
        maxHeight: '80vh',
        overflow: 'auto',
    },
    media: {
      height: 140,
    },
    errorCaption: {
        paddingTop: theme.spacing(2),
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 2,
    },
    errorDetails: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        paddingTop: theme.spacing(3.5),
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        whiteSpace: 'pre-wrap',
        overflow: 'auto',
        maxHeight: '200px',
        fontSize: '0.875rem',
        fontFamily: 'monospace',
        position: 'relative',
    },
    detailsTitle: {
        position: 'absolute',
        top: '-10px',
        left: '10px',
        padding: '0 8px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        fontWeight: 500,
        fontSize: '0.875rem',
        zIndex: 1,
    },
    divider: {
        margin: theme.spacing(1, 0, 2),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
    },
    errorIcon: {
        marginRight: theme.spacing(1),
    }
  }));

interface IOptions {
    optionLabel: string;
    optionExecute: () => void;
}

interface IDecorations {
    title: string;
    message: string;
    errorDetails?: string;
    options: IOptions[];
    canClose?: boolean;
}

export type AllProps = IDecorations;
export const ErrorMessage = (props: AllProps) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { t: tCommon } = useTranslation('common');

    const [open, setOpen] = React.useState(true);
    
    return (
        <Backdrop open={open} className={classes.backdrop} onClick={() => props.canClose && setOpen(false)}>
            <Card className={classes.root} onClick={e => e.stopPropagation()}>
                <CardContent>
                    <div className={classes.header}>
                        <ErrorIcon color="secondary" fontSize="large" className={classes.errorIcon} /> 
                        <Typography gutterBottom variant="h5" component="h2" color="error">
                            {props.title}
                        </Typography>
                    </div>
                    <Typography variant="body1" color="textPrimary" component="p">
                        {props.message}
                    </Typography>
                    
                    {props.errorDetails && (
                        <div style={{ position: 'relative', marginTop: theme.spacing(2) }}>
                            <Paper variant="outlined" className={classes.errorDetails}>
                                {props.errorDetails}
                            </Paper>
                            <Typography variant="subtitle2" className={classes.detailsTitle}>
                                Details
                            </Typography>
                        </div>
                    )}
                </CardContent>
                <CardActions>
                    {props.options.map((option, index) => (
                        <Button key={index} size="small" color="primary" onClick={option.optionExecute}>
                            {option.optionLabel}
                        </Button>
                    ))}
                    {props.canClose && (
                        <Button size="small" color="secondary" onClick={() => setOpen(false)}>
                            {tCommon('close')}
                        </Button>
                    )}
                </CardActions>
            </Card>
        </Backdrop>
    );
}

export default ErrorMessage;